import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import compose from 'recompose/compose'
import { Map } from 'immutable'
import withHandlers from 'recompose/withHandlers'
import withProps from 'recompose/withProps'
import { pluralize } from 'humanize-plus'
import { withRouter } from 'react-router'

import { makeHasGate, isOnFreePlan } from 'app/modules/gates/selectors'
import { weakUuid } from 'app/modules/playbook/helpers'
import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookModels from 'app/modules/playbook/models'
import { AudienceDisplay, TargetingDisplay, PlaybookViewConfig, RoutingType, PlaybookReportType, AudienceType } from 'app/modules/playbook/constants'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as ClassificationSelectors from 'app/modules/classification/selectors'

import Nav from './component'

const mapStateToProps = state => {
  const draft = PlaybookSelectors.draft(state)
  return {
    goals: PlaybookSelectors.orderedGoals(state),
    userListIds: PlaybookSelectors.userListIds(state),
    excludedUserListIds: PlaybookSelectors.excludedUserListIds(state),
    questions: PlaybookSelectors.questions(state),
    numQuestions: PlaybookSelectors.numQuestions(state),
    audience: PlaybookSelectors.audience(state),
    classifications: ClassificationSelectors.classificationOptions(state),
    isLeadBot: PlaybookSelectors.isLeadBot(state),
    isSignaturePlaybook: PlaybookSelectors.isSignaturePlaybook(state),
    interaction: PlaybookSelectors.interaction(state),
    isDriftLinkOnly: PlaybookSelectors.isDriftLinkOnly(state),
    isMessageTypePlaybook: PlaybookSelectors.isMessageTypePlaybook(state),
    isEmailPlaybook: PlaybookSelectors.getIsEmailPlaybook(state),
    isMarketingSequencePlaybook: PlaybookSelectors.getIsMarketingSequencePlaybook(state),
    isSequencePlaybook: PlaybookSelectors.getIsSequencePlaybook(state),
    reportType: PlaybookSelectors.reportType(state),
    targetingConditionsCount: PlaybookSelectors.getNumConditions(state),
    isOneTimeMarketingSequencePlaybook: draft.reportType === PlaybookReportType.MARKETING_ONE_TIME_SEQUENCE,
    isOutboundSequencePlaybook: PlaybookSelectors.getIsOutboundSequencePlaybook(state),
    isOnFreePlan: isOnFreePlan(state),
    hasSegmentDisplayTargeting: makeHasGate('has_segment_display_targeting')(state),
    hasModularizedAudienceBuilder: makeHasGate('has_modularized_audience_builder')(state),
    hasAccountSegmentation: makeHasGate('ACCOUNTS_SEGMENTATION')(state) // TODO: unused for now, we'll use it once the backend is ready for account segmentation
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      addGoal: PlaybookActions.addGoal,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withProps(props => ({
    hasOnlyExclusionTargeting: props.isSequencePlaybook && !props.isMarketingSequencePlaybook,
  })),
  withProps(props => {
    let targetingIconLink = 'audience'
    if (props.hasOnlyExclusionTargeting) {
      targetingIconLink = 'exclude'
    } else if (props.isLeadBot) {
      targetingIconLink = 'driftLink'
    } else if (props.isOnFreePlan) {
      targetingIconLink = 'display'
    }
    const audiencePreview = AudienceDisplay[props.audience || 'NONE']
    let audienceInclusionPreview = audiencePreview
    if (props.userListIds.size > 0 && props.audience == AudienceType.SEGMENT) {
      audienceInclusionPreview = `${props.userListIds.size} ${pluralize(props.userListIds.size, 'Segment')}`
    } else if (props.isEmailPlaybook) {
      audienceInclusionPreview = 'Segment'
    }

    const enablePlaybookLabelText = (props.isSignaturePlaybook || props.isOutboundSequencePlaybook) ? 'Enable' : props.isEmailPlaybook ? 'Send Email' : 'Enable Playbook'

    return {
      driftLink: !!props.interaction && props.interaction.get('slug'),
      audiencePreview,
      audienceInclusionPreview,
      targetingGroupTitle: props.isEmailPlaybook ? 'Audience' : 'Targeting',
      targetingIconLink,
      classificationsByGoalId: props.goals.reduce((acc, goal) => {
        const result = props.classifications.find(
          classification => classification.value === goal.classification.get('classificationId')
        )
        return !!result ? acc.set(goal.id, result.label) : acc
      }, Map()),
      hasDriftLink: props.isLeadBot,
      viewConfig: PlaybookViewConfig[props.reportType] || {},
      baseUrl: `/playbooks/${props.playbookId}/edit`,
      reviewText: enablePlaybookLabelText
    }
  }),
  withHandlers({
    renderDisplayPreview: props => () => {
      const { targetingConditionsCount } = props
      if (!targetingConditionsCount) {
        return TargetingDisplay.ALWAYS
      }
      return `${targetingConditionsCount} ${pluralize(targetingConditionsCount, 'Condition')}`
    },
    onAddGoalClick: props => () => {
      const { actions: { addGoal }, playbookId, classifications } = props
      const classificationId = _.get(classifications, '[0].value')
      const goalId = weakUuid()
      addGoal({
        goal: PlaybookModels.Goal({
          id: goalId,
          classification: Map({ classificationId: classificationId }),
          routing: PlaybookModels.RoutingOption({ type: RoutingType.GLOBAL }),
        }),
        playbookId,
      })
      props.router.push({ pathname: `/playbooks/${playbookId}/edit/goal/${goalId}` })
    },
  })
)(Nav)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Nav/index.js